import * as React from 'react';
import { useSetRecoilState } from 'recoil';
import { getDefaultCustomer, setDefaultCustomer } from '../../Services/UserService';
import {
  customersAtom,
  ICustomer,
  selectedCustomersAtom,
  selectedTempCustomersAtom,
} from '../../store/recoil/customers';
import { getCustomers } from './CustomerService';

// Aka CustomersData
function Customers(): JSX.Element | null {
  const setCustomers = useSetRecoilState<ICustomer[]>(customersAtom);
  const setSelectedCustomers = useSetRecoilState<number[]>(selectedCustomersAtom);
  const setSelectedTempCustomers = useSetRecoilState<number[]>(selectedTempCustomersAtom);

  React.useEffect(() => {
    const getCustomersData = async () => {
      const customers = await getCustomers();
      const defaultCustomers = getDefaultCustomer();

      if (customers) {
        const customerIds: number[] = customers.map((customer: ICustomer) => customer.id);

        // Remove unused customerIds from defaultCustomers, selectedCustomers and selectedTempCustomers
        const newDefaultCustomers: number[] = defaultCustomers.filter((customerId: number) =>
          customerIds.includes(customerId)
        );

        setDefaultCustomer(newDefaultCustomers);
        setSelectedCustomers(
          newDefaultCustomers.filter((customerId: number) => customerIds.includes(customerId))
        );
        setSelectedTempCustomers(
          newDefaultCustomers.filter((customerId: number) => customerIds.includes(customerId))
        );

        setCustomers(customers); // recoil
      }
    };
    getCustomersData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

export default React.memo(Customers);
